import AddIcon from "@mui/icons-material/Add";
import { Button, type ButtonProps, Typography } from "@mui/material";

const ELEVATION_SHADOW =
  "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)";

export interface IButtonAddObjectiveProps extends Pick<ButtonProps, "onClick" | "disabled"> {}

export const ButtonAddObjective = ({ onClick, disabled }: IButtonAddObjectiveProps) => (
  <Button
    startIcon={<AddIcon />}
    color="primary"
    variant="outlined"
    size="large"
    sx={{
      borderRadius: "4px",
      alignSelf: "flex-start",
      borderColor: "transparent",
      boxShadow: ELEVATION_SHADOW,
      letterSpacing: 0,
      textTransform: "none",
      "&:hover": {
        boxShadow: ELEVATION_SHADOW,
        borderColor: "transparent",
      },
    }}
    disabled={disabled}
    onClick={onClick}
  >
    <Typography variant="subtitle2SemiBold" color="primary">
      Objectif
    </Typography>
  </Button>
);
